import AppleLogoIcon from './apple-logo.svg?react'
import FacebookLogoIcon from './facebook-logo.svg?react'
import GoogleLogoIcon from './google-logo.svg?react'
import LineLogoIcon from './line-logo.svg?react'
import LineWhiteLogoIcon from './line-white-logo.svg?react'
import WhatsAppLogoIcon from './whatsapp-logo.svg?react'

export const FacebookLogo = FacebookLogoIcon
export const GoogleLogo = GoogleLogoIcon
export const LineLogo = LineLogoIcon
export const WhatsAppLogo = WhatsAppLogoIcon
export const AppleLogo = AppleLogoIcon
export const LineWhiteLogo = LineWhiteLogoIcon
